import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "enable", "onFocusOutside", "onFocus"];
import React from 'react';
import { useOnFocusOutside } from './useOnFocusOutside';
export function OutsideFocusHandlerContainer(_ref) {
  var as = _ref.as,
      enable = _ref.enable,
      onFocusOutside = _ref.onFocusOutside,
      _onFocus = _ref.onFocus,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleFocus = useOnFocusOutside(onFocusOutside, enable);
  var Component = as || 'span';
  return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
    onFocus: function onFocus(e) {
      handleFocus();

      if (typeof _onFocus === 'function') {
        _onFocus(e);
      }
    }
  }));
}
// #sourceMappingURL=OutsideFocusHandlerContainer.js.map